import { useCallback, useSyncExternalStore } from 'react'

import { debounce } from '@app/utils/debounce'

type DeviceType = 'mobile' | 'tablet' | 'desktop'

export const useDeviceType = () => {
  return useSyncExternalStore(
    useCallback(cb => {
      if (!IS_BROWSER) return () => {}
      const handler = debounce(() => {
        cb()
      }, 100)
      window.addEventListener('resize', handler)
      return () => {
        window.removeEventListener('resize', handler)
      }
    }, []),
    readDeviceType,
    () => 'desktop'
  )
}

const readDeviceType = (): DeviceType => {
  const value = getComputedStyle(document.documentElement).getPropertyValue('--device-type').trim()
  if (value === 'mobile' || value === 'tablet') return value
  return 'desktop'
}
